import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useActiveTemplateId } from './use-active-project-template';
const getAllSprintsSelector = ()=>createSelector((state)=>state.templates.project, (_, templateId)=>templateId, (project, templateId)=>project.data[templateId].sprints);
export const useGetAllSprints = ()=>{
    const templateId = useActiveTemplateId();
    const templateObject = useMemo(getAllSprintsSelector, []);
    return useSelector((state)=>templateObject(state, templateId));
};
